<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="pageSettings; else loading">
    <div class="row">
      <div class="col-md-12">
        <button class="btn btn-accent"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
      </div>
      <div class="col-md-12">
        <h2>Page Settings</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12">
            <h5>Site Title (the one in the head tag)</h5>
            <hr>
          </div>
          <div class="col-md-12 sm-padding-top">
            <label for="head-title">Title</label>
            <input class="full-width"
                   pInputText
                   id="head-title"
                   [(ngModel)]="pageSettings.title" />
          </div>

          <div class="col-md-12">
            <h5>Size Guide Climate Control Info</h5>
            <hr>
          </div>
          <div class="col-md-12 sm-padding-top">
            <label for="title">Title</label>
            <input class="full-width"
                   pInputText
                   id="title"
                   [(ngModel)]="pageSettings.sizeGuide?.sizeClimateControlledInfo.title" />
          </div>
          <div class="col-md-12 sm-padding-top">
            <label for="body">Body</label>
            <input class="full-width"
                   pInputText
                   id="body"
                   [(ngModel)]="pageSettings.sizeGuide?.sizeClimateControlledInfo.body" />
          </div>
          <div class="col-md-10 sm-padding-top margin-bottom">
            <label for="imgUrl">Climate Controlled Image URL</label>
            <input class="full-width"
                   pInputText
                   id="imgUrl"
                   [(ngModel)]="pageSettings.sizeGuide?.sizeClimateControlledInfo.imgUrl" />
          </div>
          <div class="col-md-2">
            <img [src]="pageSettings.sizeGuide?.sizeClimateControlledInfo.imgUrl"
                 class="icon-image sm-padding-top"
                 alt="">
          </div>
        </div>
      </div>

      <div class="col-md-6 sm-padding-top">
        <h5>Size Guide</h5>
        <hr>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.sizeGuide.hideButtons">
          <p> Hide Rent and Reserve Buttons on size guide</p>
        </md-slide-toggle>
        <br>
        <br>
        <label for="page-title">Page Title</label>
        <input class="full-width"
               pInputText
               id="page-title"
               [(ngModel)]="pageSettings.sizeGuide.title" />
        <br>
        <br>
        <label for="page-body">Page Body (HTML allowed)</label>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="pageSettings.sizeGuide.body"
                  id="page-body"
                  class="full-width "></textarea>

        <!-- <p-editor id="page-body"
                  class="full-width"
                  [(ngModel)]="pageSettings.sizeGuide.body"
                  [style]="{'height':'320px'}">
          <p-header>
            <span class="ql-formats">
                    <button class="ql-bold" aria-label="Bold"></button>
                    <button class="ql-italic" aria-label="Italic"></button>
                    <button class="ql-underline" aria-label="Underline"></button>
                  </span>
            <span class="ql-formats">
                    <button class="ql-list" value="ordered" aria-label="List Ordered"></button>
                    <button class="ql-list" value="bullet" aria-label="List"></button>
                  </span>
            <span class="ql-formats">
                    <button class="ql-link" aria-label="Link"></button>
                    <button class="ql-image" aria-label="Image"></button>
                  </span>
          </p-header>
        </p-editor> -->
        <!--<textarea class="full-width" pInputTextarea id="page-body" autoResize="autoResize"-->
        <!--[(ngModel)]="pageSettings.sizeGuide.body"></textarea>-->
      </div>
    </div>


    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>About Us</h5>
        <hr>
      </div>
      <!--<div class="col-md-12">-->
      <!--<p>Banner URL</p>-->
      <!--<input class="full-width" type="text" pInputText [(ngModel)]="pageSettings.about.bannerImageUrl" />-->
      <!--</div>-->
      <ng-container [ngSwitch]="clientData?.aboutUsMainSection">
        <div *ngSwitchCase="'html'"
             class="col-md-12">
          <p>Custom HTML</p>
          <textarea [froalaEditor]="options"
                    [(froalaModel)]="pageSettings.about.whoWeAre"
                    class="full-width "></textarea>
        </div>
        <ng-container *ngSwitchCase="'rows'">
          <div *ngFor="let row of pageSettings.about.rows; let i = index; let last = last; let first = first"
               [ngStyle]="{'border-bottom': last ? 'none' : '1px solid rgba(0,0,0,0.33)'}"
               class="col-xs-12 about-row">
            <div class="row">
              <div class="col-xs-12">
                <label for="about-row-title-{{i}}">Row Title</label>
                <input class="full-width"
                       pInputText
                       id="about-row-title-{{i}}"
                       [(ngModel)]="pageSettings?.about.rows[i].title" />
              </div>
              <div class="col-xs-12">
                <label for="about-row-image-{{i}}">Row Image/Video Poster URL</label>
                <input class="full-width"
                       pInputText
                       id="about-row-image-{{i}}"
                       [(ngModel)]="pageSettings?.about.rows[i].imageUrl" />
              </div>
              <div class="col-xs-12">
                <label for="about-row-image-alt-{{i}}">Row Image Alt (leave blank to use image file name)</label>
                <input class="full-width"
                       pInputText
                       id="about-row-image-{{i}}"
                       [(ngModel)]="pageSettings?.about.rows[i].imageAltText" />
              </div>
              <div class="col-xs-12">
                <label for="about-row-video-{{i}}">Row Video URL (leave blank if image only)</label>
                <input class="full-width"
                       pInputText
                       id="about-row-video-{{i}}"
                       [(ngModel)]="pageSettings?.about.rows[i].videoUrl" />
              </div>
              <div class="col-xs-12">
                <md-slide-toggle [(ngModel)]="pageSettings?.about.rows[i].borderRadius">
                  Border Radius
                </md-slide-toggle>
              </div>
              <div class="col-xs-12">
                <label for="about-row-layout-{{i}}">Row Layout</label>
                <p-dropdown id="about-row-layout-{{i}}"
                            [options]="aboutRowsLayoutOptions"
                            [(ngModel)]="pageSettings?.about.rows[i].layout"></p-dropdown>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <p>HTML</p>
                <textarea [froalaEditor]="options"
                          [(froalaModel)]="pageSettings.about.rows[i].html"
                          class="full-width"></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center">
                <button *ngIf="!first"
                        type="button"
                        class="btn btn-secondary m-2"
                        (click)="moveAboutRow('up', i)">
                  <i class="fa fa-arrow-up"></i> Move
                </button>
                <button *ngIf="!last"
                        type="button"
                        class="btn btn-secondary m-2"
                        (click)="moveAboutRow('down', i)">
                  <i class="fa fa-arrow-down"></i> Move
                </button>
                <button type="button"
                        class="btn btn-danger m-2"
                        (click)="removeAboutRow(i)">
                  Remove Row
                </button>
              </div>
            </div>
          </div>
          <div class="col-xs-12 text-center">
            <button type="button"
                    class="btn btn-accent btn-lg m-5"
                    (click)="addAboutRow()">
              Add Row
            </button>
          </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <div class="col-md-6">
            <p>Who We Are</p>
            <input class="full-width"
                   placeholder="alternate title"
                   pInputText
                   [(ngModel)]="pageSettings?.about.whoWeAreHeader" />
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="pageSettings.about.whoWeAre"
                      class="full-width "></textarea>
          </div>
          <div class="col-md-6">
            <p>Why Us?</p>
            <input class="full-width"
                   placeholder="alternate title"
                   pInputText
                   [(ngModel)]="pageSettings?.about.whyUsHeader" />
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="pageSettings.about.whyUs"
                      class="full-width "></textarea>
          </div>
          <div *ngIf="clientData?.aboutUsMainSectionData?.useSlider">
            <div class="col-xs-12">
              <br>
              <label>Slider URLs</label>
            </div>
            <div class="row"
                 *ngFor="let url of pageSettings?.about.aboutUsSliderUrls; let i = index">
              <div class="col-xs-11 sm-padding-top">
                <input class="full-width"
                       type="text"
                       pInputText
                       [(ngModel)]="pageSettings?.about.aboutUsSliderUrls[i]" />
              </div>
              <div class="col-xs-1 sm-padding-top">
                <i class="fa fa-times removeUrl"
                   (click)="removeAboutSlider(i)"
                   aria-hidden="true"></i>
              </div>
            </div>
            <div class="row padding-top">
              <div class="col-md-12">
                <button (click)="addAboutSlider()"
                        class="btn btn-secondary"
                        color="accent">Add Slider</button>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
    <div class="row sm-padding-top"
         *ngIf="clientData?.viewAllUnitsComponent === 'textOnly'">
      <div class="col-md-12">
        <h5>View Units</h5>
        <hr>
      </div>
      <!--<div class="col-md-12">-->
      <!--<md-select class="num-select"-->
      <!--[(ngModel)]="locationDropdown">-->
      <!--<md-option *ngFor="let location of clientData.locations" [value]="location.$key">-->
      <!--{{ location.name }}-->
      <!--</md-option>-->
      <!--</md-select>-->
      <!--</div>-->
      <div class="col-md-6 sm-margin-top">
        <label>Left Title</label>
        <input class="full-width"
               pInputText
               [(ngModel)]="pageSettings?.viewUnits?.leftSide.title" />
        <p>Left Body</p>
        <p-editor class="full-width"
                  [(ngModel)]="pageSettings?.viewUnits?.leftSide.cardInnerHtml"
                  [style]="{'height':'320px'}">
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold"
                      aria-label="Bold"></button>
              <button class="ql-italic"
                      aria-label="Italic"></button>
              <button class="ql-underline"
                      aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list"
                      value="ordered"
                      aria-label="List Ordered"></button>
              <button class="ql-list"
                      value="bullet"
                      aria-label="List"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-link"
                      aria-label="Link"></button>
              <button class="ql-image"
                      aria-label="Image"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
      <div class="col-md-6 sm-margin-top">
        <label>Right Title</label>
        <input class="full-width"
               pInputText
               [(ngModel)]="pageSettings?.viewUnits?.rightSide.title" />
        <p>Right Body</p>
        <p-editor class="full-width"
                  [(ngModel)]="pageSettings?.viewUnits?.rightSide.cardInnerHtml"
                  [style]="{'height':'320px'}">
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold"
                      aria-label="Bold"></button>
              <button class="ql-italic"
                      aria-label="Italic"></button>
              <button class="ql-underline"
                      aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list"
                      value="ordered"
                      aria-label="List Ordered"></button>
              <button class="ql-list"
                      value="bullet"
                      aria-label="List"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-link"
                      aria-label="Link"></button>
              <button class="ql-image"
                      aria-label="Image"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
    </div>
    <div class="row sm-padding-top">
      <div class="col-md-6">
        <h5>Home</h5>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.home.showFindUs">
          <p> Show "Find Us" Map on Home Page</p>
        </md-slide-toggle>
        <br>
        <br>
        <label for="tab-box-view-rates">View Rates Button Text</label>
        <input class="full-width"
               pInputText
               id="tab-box-view-rates"
               [(ngModel)]="pageSettings?.home.tabBoxViewRatesButtonText" />
        <label for="tab-box-pay-bill">Pay Bill Button Text</label>
        <input class="full-width"
               pInputText
               id="tab-box-pay-bill"
               [(ngModel)]="pageSettings?.home.tabBoxPayBillButtonText" />
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.home.alternateButtonLinks">
          <p>Alternate Links for buttons</p>
        </md-slide-toggle>
        <br>
        <br>
        <div *ngIf="pageSettings?.home.alternateButtonLinks === true">
          <strong>ONLY the route name, e.g. units, contact, etc.</strong>
          <label for="tab-box-view-rates-link">View Rates Button Alt Link</label>

          <input class="full-width"
                 *ngIf="!pageSettings?.home.isTabBoxViewRatesScroll"
                 pInputText
                 id="tab-box-view-rates-link"
                 [(ngModel)]="pageSettings?.home.tabBoxViewRatesButtonAltLink" />
          <br>

          <md-slide-toggle *ngIf="!pageSettings?.home.isTabBoxViewRatesScroll"
                           [(ngModel)]="pageSettings?.home.tabBoxViewRatesButtonAltLinkExcludeLocationKey">
            <p>Don't include location key when available</p>
          </md-slide-toggle>
          <br>
          <br>
          <label for="tab-box-pay-bill-link">Pay Bill Button Alt Link</label>
          <input class="full-width"
                 pInputText
                 id="tab-box-pay-bill"
                 [(ngModel)]="pageSettings?.home.tabBoxPayBillButtonAltLink" />
          <br>
          <md-slide-toggle [(ngModel)]="pageSettings?.home.tabBoxPayBillButtonAltLinkExcludeLocationKey">
            <p>Don't include location key when available</p>
          </md-slide-toggle>
        </div>
        <br>
        <br>
        <!--         <ng-container *ngIf="pageSettings?.locationHome.headerType !== 'none'">
          <label for="tab-box-view-rates">Location Home View Rates Button Text</label>
          <input class="full-width"
                 pInputText
                 id="tab-box-view-rates"
                 [(ngModel)]="pageSettings?.home.tabBoxLocationViewRatesButtonText" />
          <label for="tab-box-pay-bill">Location Home Pay Bill Button Text</label>
          <input class="full-width"
                 pInputText
                 id="tab-box-pay-bill"
                 [(ngModel)]="pageSettings?.home.tabBoxLocationPayBillButtonText" />
          <br>
          <br>
          <md-slide-toggle [(ngModel)]="pageSettings?.home.alternateButtonLinks">
            <p>Alternate Links for Location Home buttons</p>
          </md-slide-toggle>
          <br>
          <br>
          <div *ngIf="pageSettings?.home.alternateButtonLinks === true">
            <strong>ONLY the route name, e.g. units, contact, etc.</strong>
            <label for="tab-box-view-rates-link">Location Home View Rates Button Alt Link</label>
            <input class="full-width"
                   pInputText
                   id="tab-box-view-rates-link"
                   [(ngModel)]="pageSettings?.home.tabBoxLocationViewRatesButtonAltLink" />
            <br>
            <br>
            <label for="tab-box-pay-bill-link">Location Home Pay Bill Button Alt Link</label>
            <input class="full-width"
                   pInputText
                   id="tab-box-pay-bill"
                   [(ngModel)]="pageSettings?.home.tabBoxLocationPayBillButtonAltLink" />
          </div>
        </ng-container> -->
      </div>
      <div class="col-md-6">
        <h5>Rent/Reserve a Unit</h5>
        <hr>
        <div>
          <md-slide-toggle class="sm-padding-top"
                           [(ngModel)]="pageSettings?.rentAUnit.showUnavailableUnits"> Show unavailble units?
          </md-slide-toggle>
        </div>
        <div>
          <md-slide-toggle class="sm-padding-top"
                           [(ngModel)]="pageSettings?.rentAUnit.useDatePicker"> Use date picker for rentals?
          </md-slide-toggle>
        </div>
        <div *ngIf="pageSettings?.rentAUnit.useDatePicker">
          <div>Days a rental can be made in advance. Note: This number can't be zero because it will
            allow a move-in any number of days in advance.</div>
          <p-spinner [(ngModel)]="pageSettings?.rentAUnit.daysARentalCanBeMadeInAdvance"
                     [min]="1"></p-spinner>
        </div>
        <p>Days a reservation is valid.</p>
        <p-spinner [(ngModel)]="pageSettings?.reserveAUnit.daysReservationIsValid"
                   [min]="0"></p-spinner>
        <br>
        <p>Days a reservation can be made in advance.</p>
        <p-spinner [(ngModel)]="pageSettings?.reserveAUnit.daysAReservationCanBeMadeInAdvance"
                   [min]="0"></p-spinner>
        <div>
          <md-slide-toggle class="sm-padding-top"
                           [(ngModel)]="pageSettings?.reserveAUnit.useDatePicker"> Use date picker for reservations?
          </md-slide-toggle>
        </div>
        <div>
          <p-dropdown [options]="reservationFollowUpOptions"
                      [(ngModel)]="pageSettings?.reserveAUnit.followUpDay"></p-dropdown>
        </div>
        <div class="row">
          <div class="col-xs-12 sm-margin-top">
            <strong>Disable Days for Rental/Reservation Date Picker</strong>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[0]">
              Sunday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[1]">
              Monday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[2]">
              Tuesday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[3]">
              Wednesday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[4]">
              Thursday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[5]">
              Friday
            </md-slide-toggle>
          </div>
          <div class="col-xs-12 sm-margin-top">
            <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.disableDays[6]">
              Saturday
            </md-slide-toggle>
          </div>
        </div>
        <div>
          <md-slide-toggle class="sm-padding-top"
                           [(ngModel)]="pageSettings?.reserveAUnit.useFutureStartDate"> Use future start date instead
            of current date?
          </md-slide-toggle>
        </div>
        <div *ngIf="pageSettings?.reserveAUnit?.useFutureStartDate">
          <label for="reservation-future-start-date">Rental/Reservation future start date</label>
          <input class="full-width"
                 pInputText
                 type="date"
                 id="reservation-future-start-date"
                 placeholder="mm/dd/yyyy"
                 [(ngModel)]="pageSettings?.reserveAUnit.futureStartDate" />
        </div>
        <p>Gate Code Min length</p>
        <p-spinner [(ngModel)]="pageSettings.gateCodeMinLength"
                   [min]="0"></p-spinner>
        <p>Gate Code Max length</p>
        <p-spinner [(ngModel)]="pageSettings.gateCodeMaxLength"
                   [min]="0"></p-spinner>
        <div>
          <md-slide-toggle class="sm-padding-top"
                           [(ngModel)]="pageSettings.useGateCodeMaxValue">Use Gate Code Max Value?
          </md-slide-toggle>
        </div>
        <div *ngIf="pageSettings.useGateCodeMaxValue">
          <label for="gate-code-max-value">Gate Code Max Value</label>
          <input class="full-width"
                 pInputText
                 type="number"
                 id="gate-code-max-value"
                 [(ngModel)]="pageSettings.gateCodeMaxValue" />
        </div>
        <div>
          <md-slide-toggle class="sm-padding-top"
                           [(ngModel)]="pageSettings.useGateCodeMinValue">Use Gate Code Min Value?
          </md-slide-toggle>
        </div>
        <div *ngIf="pageSettings.useGateCodeMinValue">
          <label for="gate-code-min-value">Gate Code Min Value</label>
          <input class="full-width"
                 pInputText
                 type="number"
                 id="gate-code-min-value"
                 [(ngModel)]="pageSettings.gateCodeMinValue" />
        </div>
        <div class="col-xs-12 sm-margin-top">
          <md-slide-toggle [(ngModel)]="pageSettings.rentAUnit.useRentUnitBlurb">
            Add Custom Blurb on Rent Unit Page
          </md-slide-toggle>
        </div>
        <div *ngIf="pageSettings.rentAUnit.useRentUnitBlurb">
          <label for="rent-a-unit-blurb">Rent A Unit Blurb</label>
          <input class="full-width"
                 pInputText
                 type="string"
                 id="rent-a-unit-blurb"
                 [(ngModel)]="pageSettings.rentAUnit.rentUnitBlurb" />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <h5>Login Page</h5>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.login.showLocationOnForm">
          <p>Show location on login form</p>
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.login.logLogins">
          <p>Log tenant note for login</p>
        </md-slide-toggle>
        <br>
        <input pInputText
               class="full-width"
               placeholder="existing customers text"
               [(ngModel)]="pageSettings?.login.existingCustomersText" />
        <br>
        <input pInputText
               class="full-width"
               placeholder="forgot password text"
               [(ngModel)]="pageSettings?.login.forgotPasswordText" />
        <br>
      </div>
      <div class="col-md-6">
        <h5>Move in Form Settings</h5>
        <hr>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.reserveAUnit.useShortMoveInForm">Use short move-in form for
          reservations?
        </md-slide-toggle>
        <p>This will turn on the shorter move-in form for reservations instead of using the full form. Overwritten by
          location setting.</p>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.requireSsn">Require SSN on form?
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.showAlternateContact">Show alternate contact form?
        </md-slide-toggle>
        <p>This shows on move in when making a new contact. Also, when a user edits their information.</p>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.alternateContactOptional">Alternate contact optional?
        </md-slide-toggle>
        <p>make it optional to include alternate contact information</p>
        <br>
        <input pInputText
               placeholder="Alternate Contact Blurb"
               class="full-width"
               [(ngModel)]="pageSettings?.rentAUnit.alternateContactBlurb" />
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.emergencyContactInstead">"Emergency" instead of
          "Alternate"
        </md-slide-toggle>
        <p>make it say "Emergency Contact" instead of "Alternate Contact"</p>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.hideToggles">Hide toggles?
        </md-slide-toggle>
        <p>hide toggles for commercial tenant and unit for business, hide entire column with this and hide military
          column</p>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.hideMilitaryToggle">Hide military toggle?
        </md-slide-toggle>
        <p>hide toggles for only military</p>
        <br>
        <input pInputText
               placeholder="Military Selected Blurb"
               class="full-width"
               [(ngModel)]="pageSettings?.rentAUnit.militarySelectedBlurb" />
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.hideLicenseInfo">Hide license info?
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.licenseOptional">License info optional?
        </md-slide-toggle>
        <p>make it optional to include license info</p>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.showCompanyName">Show tenant company name?
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.showCompanyPhone">Show tenant company phone?
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.showDateOfBirth">Show tenant date of birth?
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.forceAutoPay">Force autopay?
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.rentAUnit.openTechPhoneTypes">Opentech phone type names?
        </md-slide-toggle>
        <p>Home Phone -> Primary Phone and Cell Phone -> Additional Phone</p>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <h5>Customer Portal</h5>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.portal.notifyOfChanges">
          <p> Notify client of account info changes.</p>
        </md-slide-toggle>
        <br>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.portal.showMoveOut">
          <p> Show move out button on unit page</p>
        </md-slide-toggle>
        <div *ngIf="pageSettings?.portal.showMoveOut"
             class="my-2">
          <p>Minimum days move out notice can be made in advance (leave blank for no restrictions)</p>
          <p-spinner [(ngModel)]="pageSettings?.portal.minimumMoveOutDays"
                     [min]="0"></p-spinner>
          <p>Maximum days move out notice can be made in advance (leave blank for no restrictions)</p>
          <p-spinner [(ngModel)]="pageSettings?.portal.maximumMoveOutDays"
                     [min]="0"></p-spinner>
        </div>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.portal.showAutopayOnPortalHome">
          <p> Show autopay on portal home</p>
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.portal.showReviewButton">
          <p> Show review button on portal home</p>
        </md-slide-toggle>
        <br>
        <br>
        <input pInputText
               placeholder="Autopay page blurb"
               class="full-width"
               [(ngModel)]="pageSettings?.portal.autopayBlurb" />
        <br>
        <input pInputText
               class="full-width"
               *ngIf="pageSettings?.portal.showReviewButton === true"
               placeholder="review button text"
               [(ngModel)]="pageSettings?.portal.reviewButtonText" />
        <br>
        <input pInputText
               class="full-width"
               *ngIf="pageSettings?.portal.showReviewButton === true"
               placeholder="review button URL"
               [(ngModel)]="pageSettings?.portal.reviewButtonUrl" />

      </div>
      <div class="col-md-6">
        <h5>Contact Page</h5>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.contact.showInfoOnMap">
          <p> Show info box on map</p>
        </md-slide-toggle>
        <br>
        <md-slide-toggle [(ngModel)]="pageSettings?.contact.routeEmailToContact">
          <p> Make all "Email Us" links route to Contact page</p>
        </md-slide-toggle>
        <br>
        <h5>Title</h5>
        <br>
        <input pInputText
               placeholder="Contact Us"
               [(ngModel)]="pageSettings?.contact.title" />
        <br>
        <h5>Subtitle</h5>
        <br>
        <input pInputText
               placeholder="Drop Us a Line"
               [(ngModel)]="pageSettings?.contact.subtitle" />
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5>Reviews</h5>
        <hr>
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Page Title (in header)</label>
        <input pInputText
               [(ngModel)]="pageSettings?.reviews.pageTitle" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Leave a review link URL</label>
        <input pInputText
               [(ngModel)]="pageSettings?.reviews.reviewLinkUrl" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Meta Title</label>
        <input pInputText
               [(ngModel)]="pageSettings?.reviews.metaTitle" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <p>
          <b>Location image is used by default. If you put one here it overides that.</b>
        </p>
        <label>Meta Image</label>
        <input pInputText
               [(ngModel)]="pageSettings?.reviews.metaImage" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Meta Image Alt</label>
        <input pInputText
               [(ngModel)]="pageSettings?.reviews.metaImageAlt" />
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Meta Description</label>
        <textarea pInputTextarea
                  class="full-width text-area-box"
                  [(ngModel)]="pageSettings?.reviews.metaDescription"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5>Portable Quote</h5>
        <hr>
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <div class="row sm-margin-top">
          <div class="col-xs-12">
            <md-slide-toggle [(ngModel)]="pageSettings?.portableQuote.showHtmlRow">
              <p>Show html row on top of quote page</p>
            </md-slide-toggle>
            <md-slide-toggle [(ngModel)]="pageSettings?.portableQuote.showImages">
              <p>Show Slideshow on bottom of quote page</p>
            </md-slide-toggle>
            <md-slide-toggle [(ngModel)]="pageSettings?.portableQuote.showSliderArrows">
              <p>Show Arrows</p>
            </md-slide-toggle>
            <md-slide-toggle [(ngModel)]="pageSettings?.portableQuote.sliderAutoPlay">
              <p>Autoplay Slider</p>
            </md-slide-toggle>
          </div>
        </div>
        <div class="row sm-margin-top"
             *ngFor="let url of pageSettings?.portableQuote?.sliderUrls; let i = index">
          <div class="col-xs-11 sm-padding-top">
            <input class="full-width"
                   type="text"
                   pInputText
                   [(ngModel)]="pageSettings?.portableQuote?.sliderUrls[i]" />
          </div>
          <div class="col-xs-1 sm-padding-top">
            <i class="fa fa-times removeUrl"
               (click)="removePortableQuotePageSlider(i)"
               aria-hidden="true"></i>
          </div>
        </div>
        <div class="row sm-margin-top">
          <div class="col-xs-12">
            <button (click)="addPortableQuotePageSlider()"
                    class="btn btn-secondary"
                    color="accent">Add Slider</button>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 sm-margin-top">
        <label>Blurb Below Slideshow</label>
        <textarea pInputTextarea
                  class="full-width"
                  [froalaEditor]="options"
                  [(froalaModel)]="pageSettings?.portableQuote.imagesBlurb">
                </textarea>
      </div>
      <div *ngIf="pageSettings?.portableQuote?.showHtmlRow"
           class="col-xs-12 sm-margin-top">
        <label>Portable Quote HTML Row</label>
        <textarea pInputTextarea
                  class="full-width"
                  [froalaEditor]="options"
                  [(froalaModel)]="pageSettings?.portableQuote.htmlRowHtml"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5>FAQs</h5>
        <hr>
      </div>
      <div class="col-md-6">
        <scs-faqs [pageSettings]="pageSettings"
                  [clientData]="clientData"
                  [side]="'leftColumn'"></scs-faqs>
      </div>
      <div class="col-md-6">
        <scs-faqs [pageSettings]="pageSettings"
                  [clientData]="clientData"
                  [side]="'rightColumn'"></scs-faqs>
      </div>
      <div class="col-xs-12 sm-margin-top">
        <p>
          <b>If you want a blurb, check the setting in styles. Note that a left side placement will hide the right
            column faqs, and the left column faqs will be on the right.</b>
        </p>
        <label>Blurb Title</label>
        <input pInputText
               [(ngModel)]="pageSettings?.faqs.blurbTitle" />
      </div>
      <div class="col-md-12">
        <p>Blurb</p>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="pageSettings.faqs.blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <h5>Storage Tips</h5>
        <hr>
      </div>
      <div class="col-md-6">
        <scs-storage-tips [pageSettings]="pageSettings"
                          [clientData]="clientData"
                          [side]="'leftColumn'"></scs-storage-tips>
      </div>
      <div class="col-md-6">
        <scs-storage-tips [pageSettings]="pageSettings"
                          [clientData]="clientData"
                          [side]="'rightColumn'"></scs-storage-tips>
      </div>
      <div class="col-xs-12 sm-margin-top">
        <label>Blurb Title</label>
        <input pInputText
               [(ngModel)]="pageSettings?.storageTips.blurbTitle" />
      </div>
      <div class="col-md-12">
        <p>Blurb</p>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="pageSettings.storageTips.blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <h5>General Information Sections <button style="float:right"
                  (click)="addGeneralInfoSection()"
                  class="btn btn-lg btn-secondary">Add Section</button></h5>
        <hr>
      </div>
      <div class="col-xs-12">
        <div *ngFor="let section of pageSettings?.generalInfo?.sections; index as index"
             class="row"
             style="margin-top:15px;margin-bottom:15px">
          <div class="col-xs-12">
            <input pInputText
                   style="margin-bottom:10px;display:inline-block"
                   placeholder="title"
                   (blur)="createClassName(section)"
                   [(ngModel)]="section.title" />
            <button type="button"
                    class="btn btn-danger"
                    style="margin-left:5%"
                    (click)="removeGeneralInfoSection(index)">X</button>
          </div>
          <div class="col-xs-12">
            <textarea [froalaEditor]="options"
                      [(froalaModel)]="section.body"
                      class="full-width"></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>Storage Calculator</h5>
        <hr>
      </div>
      <div class="col-md-12">
        <p>Blurb</p>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="pageSettings.storageCalculator.blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row sm-padding-top">
      <div class="col-md-12">
        <h5>Select Location</h5>
        <hr>
      </div>
      <div class="col-md-12">
        <p>Blurb</p>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="pageSettings.selectLocation.blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h5>Move Out Notice</h5>
        <hr>
      </div>
      <div class="col-md-6 sm-padding-top">
        <label>Page Title</label>
        <input pInputText
               [(ngModel)]="pageSettings?.moveOutNoLogin.title" />
        <p>Blurb</p>
        <textarea [froalaEditor]="options"
                  [(froalaModel)]="pageSettings?.moveOutNoLogin.blurb"
                  class="full-width"></textarea>
      </div>
    </div>

    <div class="row margin-top">
      <div class="col-md-12">
        <h5>Privacy Policy</h5>
        <hr>
      </div>
      <div class="col-md-6 sm-padding-top">
        <md-slide-toggle [(ngModel)]="pageSettings?.privacyPolicy.showPrivacyPolicy">
          <p>Use a privacy policy</p>
        </md-slide-toggle>
        <br>
        <label for="page-body">Page Body (HTML allowed)</label>
        <p-editor id="page-body"
                  class="full-width"
                  [(ngModel)]="pageSettings.privacyPolicy.body"
                  [style]="{'height':'320px'}">
          <p-header>
            <span class="ql-formats">
              <button class="ql-bold"
                      aria-label="Bold"></button>
              <button class="ql-italic"
                      aria-label="Italic"></button>
              <button class="ql-underline"
                      aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-list"
                      value="ordered"
                      aria-label="List Ordered"></button>
              <button class="ql-list"
                      value="bullet"
                      aria-label="List"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-link"
                      aria-label="Link"></button>
              <button class="ql-image"
                      aria-label="Image"></button>
            </span>
          </p-header>
        </p-editor>
      </div>
      <div class="col-md-6 sm-padding-top">
      </div>
    </div>

    <div class="row padding-top">
      <div class="col-md-12">
        <button style="float: right;"
                (click)="savePageSettings()"
                class="btn btn-lg btn-secondary"
                color="accent">Update</button>
      </div>
    </div>

  </md-card>
</div>
<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/page-settings/page-settings.component.html